<div class="table-tr">
	<div class="table-th">
		<qo-select-dropdown
			text="{{ 'SCHEDULE.SORTING' | translate }}"
			[shadow]="shadows.MEDIUM"
			[actions]="filterActions"
		></qo-select-dropdown>
	</div>
	<div class="table-th" *ngFor="let date of (selectedDates$ | async)">
		<div class="date">{{date | smLocalDate:'EEE d'}}</div>
		<div class="shift-count">{{dateToShiftsAmount[date.format('YYYY-MM-DD')]}} {{ 'SCHEDULE.SHIFTS' | translate }}</div>
		<div class="note add-note"
				 (click)="addNote(date)"
				 *ngIf="!dateToDayNotes[date.format('YYYY-MM-DD')] && (user$ | async).isAdmin()"
		>{{ 'DAY_NOTES.ADD' | translate }}</div>
		<div class="note view-notes" (click)="viewNotes(date)"
				 *ngIf="dateToDayNotes[date.format('YYYY-MM-DD')]">{{ 'DAY_NOTES.VIEW' | translate }}</div>
		<ng-container *ngIf="(printing$ | async)">
			<div class="print-daynote-title">
				{{'SCHEDULE.DAY_NOTES' | translate}}
			</div>
			<ul class="notes">
				<ng-container *ngFor="let dayNote of dateToDayNotes[date.format('YYYY-MM-DD')]">
					<li class="item" *ngIf="!dayNote.hidden_note">
						{{dayNote.note}}
					</li>
				</ng-container>
			</ul>
		</ng-container>
	</div>
</div>
